import * as R from 'ramda'
import Moment from 'moment'
import { createSearchAction, getSearchSelectors } from 'redux-search'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { makePropSelector, sort, currentDate } from './common'
import { properties, tenants, leases, allTransactions, allTypesTransactions } from './entities'
import { commentsByObjectID } from './index'
import { filteredCollection } from './filters'
import { attachmentsByObjectID } from './attachments'
import { termsByLeaseID } from './index'
import { getTimezoneDate, getMonth } from 'utils/date'
import { ledgerByTenantID } from './tenant'

let sortOptions = (currentSort) => ({
	secondary: currentSort.sortBy == 'dateTill' ? 'property' : 'dateTill'
  , secondaryDirection: 'ASC'
})

export let leasesEx = createSelector(
	[filteredCollection('lease'), ledgerByTenantID, properties, tenants, termsByLeaseID, commentsByObjectID, attachmentsByObjectID, sort('lease', sortOptions)]
  , (leases, ledgerByTenantID, properties, tenants, termsByLeaseID, commentsByObjectID, attachmentsByObjectID, sort) => {
	  	let extend = lease => {
			let tenantID = lease.tenantID || lease.tenantsID || lease.tenantsIDs && lease.tenantsIDs.length && lease.tenantsIDs[0]
			let tenant = tenants[tenantID] && (tenants[tenantID].tenant || (tenants[tenantID].firstName + " " + tenants[tenantID].lastName))
			if (lease.parentID) return false
			let terms = R.sortBy(R.prop('dateTill'))(termsByLeaseID[lease._id] || [])
			let lastTermDateTill = terms && terms.length ? getTimezoneDate(terms[terms.length-1].dateTill) : getTimezoneDate(lease.dateTill)
			let lastTermRent = terms && terms.length && terms[terms.length-1].rent
			let lastTransaction = ledgerByTenantID[tenantID] && ledgerByTenantID[tenantID][0]
			let balance = lastTransaction && lastTransaction.balance
			return {
				...lease
				 , property: properties[lease.propertyID] && properties[lease.propertyID].alias
				 , tenant
				 , balance: balance || 0
				 , comments: commentsByObjectID[lease._id] || []
				 , attachments: attachmentsByObjectID[lease._id] || []
				 , dateFrom: !lease.dateFrom?"":getTimezoneDate(lease.dateFrom)
				 , dateTill: (lease.breakDateTill && getTimezoneDate(lease.breakDateTill)) || lastTermDateTill || ""
				 , rent: lastTermRent || lease.rent
				 , id: lease._id
				 , rentString: (lastTermRent || lease.rent || 0).toString()
				 , dateFromString: lease.dateFrom ? `${getTimezoneDate(lease.dateFrom).getDate()} ${getMonth(getTimezoneDate(lease.dateFrom).getMonth())} ${getTimezoneDate(lease.dateFrom).getFullYear()}` : ''
				 , dateTillString: lastTermDateTill ? `${getTimezoneDate(lastTermDateTill).getDate()} ${getMonth(getTimezoneDate(lastTermDateTill).getMonth())} ${getTimezoneDate(lastTermDateTill).getFullYear()}` : ''
		    }
	  	}
	  	return R.pipe(R.map(extend), R.filter(x => x)/*, sort.fn*/)(leases)
	}
  , 'leasesEx'
)
// export default createSelector(
// 	[filteredCollection('task'), db, currentUser, tasksByProjectID, properties, commentsByObjectID, attachmentsByObjectID, managers, (state)=>sort('task', sortOptions(state))(state)]
//   , (tasks, db, currentUser, tasksByProjectID, properties, commentsByObjectID, attachmentsByObjectID, managers, sort)=> {
//
// 	  let project = task.projectID && db[task.projectID]&& (db[task.projectID].title[0].toUpperCase()+db[task.projectID].title.slice(1)) || ""
// 	  if (project){
// 		  return({
// 		  	  ...taskStatusTable(R.values(tasks))(task)
// 		    , manager: task.managerID && managers[task.managerID] && managers[task.managerID].name
// 		    , project: project
// 			, property:(task.propertyID && properties[task.propertyID])? properties[task.propertyID].alias:
// 				task.projectID && db[task.projectID] && db[task.projectID].propertyID?properties[db[task.projectID].propertyID]&&properties[db[task.projectID].propertyID].alias || "":""
// 		    , doneTime: (task.doneTime)? Moment(task.doneTime).format("MM/DD/YY") : undefined
// 		    , dependsOnEnded: (task.dependencies)? R.all((taskID) => (tasks[taskID])? tasks[taskID].done : true)(task.dependencies) : true
// 		    , comments: commentsByObjectID[task._id] || []
// 			, taskType: task.taskType || "Admin"
// 		    , attachments: attachmentsByObjectID[task._id] || []
// 	  	  })
// 	  }
// }
// 		//let ex = extendTask(projects, tasks, properties, managers)
// 		return R.pipe(R.filter(extendTask), R.map(extendTask), sort.fn)(tasks)
// 	}
// )

let {
	text
  , result //  ids
  , unfilteredResult
} = getSearchSelectors({
  resourceName: 'lease',
  resourceSelector: (resourceName, state) => {let res = leasesEx(state); return res}
})
export let leasesTable = createSelector(
	[leasesEx, text, result, unfilteredResult, sort('lease', sortOptions)],
	(leasesEx, text, result, unfilteredResult, sort) => {
		// console.log("leasesTable", text, unfilteredResult, result, leasesEx);
		if(text) {
			// console.log("task tasksEx", tasksEx)
			// console.log("task text", text)
			// console.log("task result", result)
			leasesEx = R.filter(x=>x)(R.map(id => leasesEx[id], unfilteredResult))
			// console.log("task tasksEx MAPPED", tasksEx)
		}
		// else console.log('unfiltered tasks', sort.fn(tasksEx))
		return sort.fn(leasesEx)

 	}
 )



export let leasesExByPropertyID = createSelector(leasesEx, R.pipe(R.values, R.groupBy(R.prop('propertyID'))))

export let leasesByPropertyID = createSelector(leases, R.pipe(R.values, R.groupBy(R.prop('propertyID'))))
export let leasesByTenantID = createSelector(leases, R.pipe(R.values, R.groupBy(R.prop('tenantID'))))

export let lastPropertyLease = createSelector(
	[leasesByPropertyID, makePropSelector('propertyID'), currentDate, leases, termsByLeaseID]
  , (leasesByPropertyID, propertyID, currentDate, AllLeases, termsByLeaseID) => {
	  let leases = R.filter(x=> !x.parentID)(leasesByPropertyID[propertyID] || [])
		leases = R.map(x => {
			let dateTill
			let terms = R.sortBy(R.prop('dateTill'))(termsByLeaseID[x._id] || [])
			let lastTerm = terms.length && terms[terms.length-1] || {}
			dateTill = x.breakDateTill || lastTerm.dateTill || x.dateTill
			return {...x, dateTill}
		})(leases || [])

	  let currentLease = R.filter( x => {
		  if (Moment(x.dateTill).format("YYYY-MM-DD") >= Moment(currentDate).format("YYYY-MM-DD") && Moment(x.dateFrom).format("YYYY-MM-DD") <= Moment(currentDate).format("YYYY-MM-DD") ){
 // debugger
			  return true
		  }
		  return false
	  })(leases)
	  let lastLease = {
		  ...(currentLease && currentLease[0] || leases[0])
	    , ...R.reduce(R.maxBy(x => Moment(x.end, 'MM-DD-YYYY')), {end: Moment('2000-01-01')}, leasesByPropertyID[propertyID] || [])
	  }
	  return lastLease
  }
)

export let lastTenantLease = createSelector(
	[leasesByPropertyID, makePropSelector('tenantID'), leasesByTenantID]
  , (leasesByPropertyID, tenantID, leasesByTenantID) => {
	  return R.reverse(R.sortBy(R.prop('dateTill'))(leasesByTenantID[tenantID] || []))[0]
  }
)

export let leasesByApplicationID = createSelector(leases, R.pipe(R.values, R.groupBy(R.prop('applicationID'))))



// WEBPACK FOOTER //
// ./src/selectors/leases.js